import { useCallback } from "react";
import { useIntl } from "react-intl";
import { useIntlTokens } from "../../../../components/mobile/useIntlTokens";

export function useGetWidgetTypeTitle() {
  const intl = useIntl();
  const intl_tokens = useIntlTokens();
  return useCallback(
    (typename: string) => {
      switch (typename) {
        case "WidgetCalendarOverview":
          return intl_tokens.Calendar;
        case "WidgetTeamSchedule":
          return intl_tokens.TeamSchedule;
        case "WidgetWeather":
          return intl.formatMessage({
            defaultMessage: "Weather",
            description: "getWidgetTypeTitle WidgetWeather",
          });
        case "WidgetTaskSingle":
          return intl.formatMessage({
            defaultMessage: "Task",
            description: "getWidgetTypeTitle WidgetTaskSingle",
          });
        case "WidgetTaskCollection":
          return intl.formatMessage({
            defaultMessage: "Tasks",
            description: "getWidgetTypeTitle WidgetTaskCollection",
          });
        case "WidgetIssueOverview":
          return intl_tokens.AllIssues;
        case "WidgetRoutineOverview":
          return intl_tokens.Checklists;
        case "WidgetSignalOverview":
          return intl.formatMessage({
            defaultMessage: "Signals",
            description: "getWidgetTypeTitle WidgetSignalOverview",
          });
        case "WidgetRoutinePositivePercentage":
          return intl.formatMessage({
            defaultMessage: "Checklist Status",
            description: "getWidgetTypeTitle WidgetRoutinePositivePercentage",
          });
        case "WidgetNote":
          return intl.formatMessage({
            defaultMessage: "Note",
            description: "getWidgetTypeTitle WidgetNote",
          });
        default:
          return "";
      }
    },
    [
      intl_tokens.Calendar,
      intl_tokens.TeamSchedule,
      intl_tokens.AllIssues,
      intl_tokens.Checklists,
      intl,
    ]
  );
}
